import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../../deps';

import './ArtistSplitPane.scss';

const ArtistSplitPane = ({ left, right, leftExpanded, noPadding }) => {
  if (!left && !right) return null;

  const classNames = D.createBEM('ArtistSplitPane', {
    leftExpanded,
    noPadding,
  });

  return (
    <div className={classNames}>
      {left && <div className='ArtistSplitPane__left'>{left}</div>}
      {right && !leftExpanded && <div className='ArtistSplitPane__right'>{right}</div>}
    </div>
  );
};

ArtistSplitPane.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
  noPadding: PropTypes.bool,
  leftExpanded: PropTypes.bool,
};

export default ArtistSplitPane;
